import { createContext, useState, useEffect } from "react";
import { getLocalCart, fetchServerCart } from "./services/CartServices";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cart, setCart] = useState([]);

  useEffect(() => {
    const loadCart = async () => {
      const token = localStorage.getItem("token");
      if (token) {
        try {
          const res = await fetchServerCart();
          setCart(res.items || []);
        } catch {
          setCart([]);
        }
      } else {
        setCart(getLocalCart());
      }
    };

    loadCart();

    const handleCartUpdate = () => {
      const token = localStorage.getItem("token");
      if (token) {
        fetchServerCart().then(res => setCart(res.items || []));
      } else {
        setCart(getLocalCart());
      }
    };

    const handleLogout = () => setCart([]); // <-- Clear cart on logout

    window.addEventListener("cartUpdated", handleCartUpdate);
    window.addEventListener("logout", handleLogout);

    return () => {
      window.removeEventListener("cartUpdated", handleCartUpdate);
      window.removeEventListener("logout", handleLogout);
    };
  }, []);

  return (
    <CartContext.Provider value={{ cart, setCart }}>
      {children}
    </CartContext.Provider>
  );
};